type TBaseUserData = {
  id: number;
  username: string;
  avatar: null | string;
};

export type User = TBaseUserData & {
  wallets: string[];
  walletsBalances: Record<string, number>;
  isBanned: boolean
};

export type TVolumeUserData = TBaseUserData & {
  totalSalesVolume: number;
};

export enum SortBy {
  CREATED_AT = 'createdAt',
  USERNAME = 'username',
}
